<!--
Copyright (c) 2022-2025 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1726_192)">
            <path d="M14 1.5H19V6.5H14V1.5Z" stroke="white" stroke-width="2"/>
            <path d="M14 13.5H19V18.5H14V13.5Z" stroke="white" stroke-width="2"/>
            <path d="M1 7.5H6V12.5H1V7.5Z" stroke="white" stroke-width="2"/>
            <path d="M7 10V10C8.65685 10 10 8.65685 10 7V7C10 5.34315 11.3431 4 13 4V4" stroke="white" stroke-width="2"/>
            <path d="M13 16V16C11.3431 16 10 14.6569 10 13V13C10 11.3431 8.65685 10 7 10V10" stroke="white" stroke-width="2"/>
        </g>
    </svg>
</template>
